import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { EventHeaderButtons, EventHeaderSeriesDropdown } from '..';
import { constants, types } from '@eb/event-create-publish-utils';
import { POSTPONED_STATUS } from './constants';
const { STATUS_DISPLAY_MAP_UPPERCASE } = constants;
const {
    SERIES_CHILD_PROPTYPES,
    EVENT_IDS_PROPTYPES,
    EVENT_SALES_STATUS_PROPTYPE,
} = types;
/**
 * Gets the status to display on the event header in classic create
 *
 * This function combines the use of the event status (status)
 * or the sales status (eventSalesStatus) to determine what
 * to display in the event header.
 *
 * Note: For now, the only sales status this function supports
 * is "event_postponed".
 *
 * @function
 * @param {string} status - event status (e.g. live, draft)
 * @param {string} eventSalesStatus - Sales status of event (e.g. postponed)
 * @returns {string} - Status string to be shown in the event header
 */
export const getEventHeaderDisplayStatus = (
    status,
    eventSalesStatus,
    launchPostponeEventClassicCreate,
) => {
    return launchPostponeEventClassicCreate &&
        eventSalesStatus.salesStatusMessageCode == 'event_postponed'
        ? POSTPONED_STATUS
        : STATUS_DISPLAY_MAP_UPPERCASE[status];
};

const EventHeaderInformation = ({
    address,
    eventDateRange,
    name,
    status,
    seriesDropdown,
    isSeriesChild,
}) => {
    const eventInfo = (
        <div>
            <p className="eds-text-bs eds-text-weight--heavy eds-text-color--grey-700">
                {status}
            </p>
            <h2 className="eds-text-hs eds-text-weight--light">{name}</h2>
            <p className="eds-text-bm eds-show-up-md  l-pad-top-1 eds-text-weight--regular eds-text-color--grey-600">
                {address}
            </p>
            {!isSeriesChild && (
                <p
                    className="eds-text-bm eds-text-weight--regular eds-text-color--grey-600"
                    data-automation="event-date-range"
                >
                    {eventDateRange}
                </p>
            )}
            {seriesDropdown}
        </div>
    );

    return (
        <div>
            <div className="eds-show-up-md">{eventInfo}</div>
            <div className="eds-show-down-mn eds-text--center">{eventInfo}</div>
        </div>
    );
};

export default class EventHeader extends PureComponent {
    static propTypes = {
        eventButtonsToShow: PropTypes.shape({
            isPreviewShown: PropTypes.bool.isRequired,
            isPublishShown: PropTypes.bool.isRequired,
            isViewShown: PropTypes.bool.isRequired,
        }).isRequired,
        eventDateRange: PropTypes.string.isRequired,
        eventIds: EVENT_IDS_PROPTYPES.isRequired,
        isSaved: PropTypes.bool.isRequired,
        isSeriesChild: PropTypes.bool.isRequired,
        eventStatusData: PropTypes.shape({
            name: PropTypes.string.isRequired,
            organizerId: PropTypes.string.isRequired,
            start: PropTypes.string.isRequired,
            status: PropTypes.string.isRequired,
            address: PropTypes.string,
            changed: PropTypes.datetime,
        }).isRequired,
        seriesChildrenData: SERIES_CHILD_PROPTYPES,
        eventSalesStatus: EVENT_SALES_STATUS_PROPTYPE,
        launchPostponeEventClassicCreate: PropTypes.bool,
    };
    static defaultProps = {
        eventSalesStatus: {
            salesStatusMessageCode: null,
        },
        launchPostponeEventClassicCreate: false,
    };

    render() {
        const {
            eventButtonsToShow,
            eventDateRange,
            eventIds,
            eventStatusData,
            eventSalesStatus,
            isSeriesChild,
            seriesChildrenData,
            manageHeaderAndNavUrls,
            launchPostponeEventClassicCreate,
        } = this.props;
        const {
            address,
            changedDate,
            changedDateTz,
            locale,
            name,
            status,
        } = eventStatusData;
        let seriesDropdown = null;

        if (seriesChildrenData) {
            seriesDropdown = (
                <EventHeaderSeriesDropdown
                    eventIds={eventIds}
                    isSeriesChild={isSeriesChild}
                    seriesChildrenData={seriesChildrenData}
                />
            );
        }

        const eventHeaderInfoClasses =
            'eds-g-cell eds-g-cell--has-overflow eds-g-cell-12-12 eds-g-cell-md-8-12 eds-l-pad-bot-3';
        const eventHeaderButtonClasses =
            'eds-g-cell eds-g-cell-12-12 eds-g-cell-md-4-12 eds-l-md-mar-top-6 eds-l-mw-mar-top-6 eds-l-ln-mar-top-6 eds-l-lg-mar-top-6 eds-l-lw-mar-top-6';

        return (
            <div className="eds-g-grid">
                <div className="eds-g-group eds-l-pad-vert-5 eds-l-pad-hor-6">
                    <div className={eventHeaderInfoClasses}>
                        <EventHeaderInformation
                            address={address}
                            eventDateRange={eventDateRange}
                            name={name}
                            seriesDropdown={seriesDropdown}
                            status={getEventHeaderDisplayStatus(
                                status,
                                eventSalesStatus,
                                launchPostponeEventClassicCreate,
                            )}
                            isSeriesChild={isSeriesChild}
                        />
                    </div>
                    <div className={eventHeaderButtonClasses}>
                        <EventHeaderButtons
                            changedDate={changedDate}
                            changedDateTz={changedDateTz}
                            locale={locale}
                            eventButtonsToShow={eventButtonsToShow}
                            manageHeaderAndNavUrls={manageHeaderAndNavUrls}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
